import bunkeringIcon from 'assets/svg/components/map/bunkering.svg';
import guardsIcon from 'assets/svg/components/map/guards.svg';
import dischargeIcon from 'assets/svg/components/map/container-discharge.svg';
import loadingIcon from 'assets/svg/components/map/container-load.svg';
import ownIcon from 'assets/svg/components/map/own.svg';
import deliveryIcon from 'assets/svg/components/map/delivery.svg';
import redeliveryIcon from 'assets/svg/components/map/redelivery.svg';
import transitIcon from 'assets/svg/components/map/transit.svg';

import bunkeringIconRed from 'assets/svg/components/map/bunkering-red.svg';
import guardsIconRed from 'assets/svg/components/map/guards-red.svg';
import dischargeIconRed from 'assets/svg/components/map/discharge-red.svg';
import loadingIconRed from 'assets/svg/components/map/loading-red.svg';
import ownIconRed from 'assets/svg/components/map/own-red.svg';
import deliveryIconRed from 'assets/svg/components/map/delivery-red.svg';
import redeliveryIconRed from 'assets/svg/components/map/redelivery-red.svg';
import transitIconRed from 'assets/svg/components/map/transit-red.svg';

export const getPolygonSource = coords => {
  return {
    type: 'geojson',
    data: {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: coords
      }
    }
  };
};

const getIcon = (action, mapStyle) => {
  let icon;
  switch (action) {
    case 'bnk':
      icon = mapStyle === 'satellite' ? bunkeringIconRed : bunkeringIcon;
      break;
    case 'd':
      icon = mapStyle === 'satellite' ? dischargeIconRed : dischargeIcon;

      break;
    case 'l':
      icon = mapStyle === 'satellite' ? loadingIconRed : loadingIcon;
      break;
    case 'own':
      icon = mapStyle === 'satellite' ? ownIconRed : ownIcon;

      break;
    case 'dlv':
      icon = mapStyle === 'satellite' ? deliveryIconRed : deliveryIcon;

      break;
    case 'rdl':
      icon = mapStyle === 'satellite' ? redeliveryIconRed : redeliveryIcon;

      break;
    case 'trn':
      icon = mapStyle === 'satellite' ? transitIconRed : transitIcon;

      break;
    case 'grd':
      icon = mapStyle === 'satellite' ? guardsIconRed : guardsIcon;

      break;
    default:
      icon = null;
  }
  return icon;
};

export const transformPorts = (ports = [], mapStyle) => {
  return ports
    .filter(el => {
      return !Number.isNaN(el.position.lng) && !Number.isNaN(el.position.lat);
    })
    .map(port => {
      return {
        port_name: port?.port_name,
        port_code: port?.port_code,
        port_id: port?.port_id,
        icons: port.actions.map(action => getIcon(action, mapStyle)),
        coords: [port.position.lng, port.position.lat]
      };
    });
};

// transform coordinates that pass from the antimeridian
export const transformCoords = points => {
  // if a vessel passes from the antimeridian, we must create 2 datasets
  // and then render both of them on the map
  // eg [[179.333,44],[-179,33,44]] --> [[[179.333,44],[180,44]],[[-180,44],[-179,33,44]] ]

  if (!points || (Array.isArray(points) && points.length === 0)) return null;
  let result = [[]];
  let i = 0;
  points.forEach((point, index) => {
    let prevLng = index === 0 ? 0 : parseFloat(points[index - 1].lon);
    let lng = parseFloat(point.lon);
    let lat = parseFloat(point.lat);

    if (
      Math.abs(prevLng + lng) < 15 &&
      Math.sign(prevLng) !== Math.sign(lng) &&
      Math.abs(prevLng) + Math.abs(lng) > 15 &&
      (Math.abs(prevLng) > 170 || Math.abs(lng) > 170)
    ) {
      result[i].push([180, lat]);

      i++;
      result[i] = [[-180, lat]];
      result[i].push([lng, lat]);
    } else {
      result[i].push([lng, lat]);
    }
  });

  return result;
};
